import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";

const FieldForceAccountEditRecipientsFailed = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const errorMessage =
    location.state?.errorMessage ||
    "Unable to update recipients. Please try again.";

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => dispatch(setHideBreadCrumb({ hide: false }));
  }, [dispatch]);

  const viewDetails = () =>
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
      { replace: true },
    );

  const buttonRows = [
    [
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--negative-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetails,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--negative-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () =>
          navigate("/field_force_account_dashboard", { replace: true }),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  return (
    <StatusContainer
      status="error"
      title="Failed to update account details, Try again later."
      buttonRows={buttonRows}
      hoverOption="white"
    >
      <TabsWeapperSection title="Error details">
        <InfoCard
          bgColor="var(--negative-card)"
          rows={[
            {
              leftTitle: errorMessage,
              leftSubTitle: "Error description",
            },
          ]}
        />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default FieldForceAccountEditRecipientsFailed;
